import { PageId } from 'constants/pages'

export const enum PageIdWoofzEaster65 {
  SUBSCRIPTIONS_EASTER_65 = PageId.SUBSCRIPTIONS_EASTER_65,
  CHAT_UPSELL_EASTER_65 = PageId.CHAT_UPSELL_EASTER_65,
  UPSELL_EASTER_65 = PageId.UPSELL_EASTER_65,
  DOWNLOAD_EASTER_65 = PageId.DOWNLOAD_EASTER_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
